import React from "react"
import Skeleton from "react-loading-skeleton"
import DynamicSkeleton from "../../components/DynamicSkeleton"

const columnConfig = {
  Mobile: { content: <Skeleton height="20px" width="120px" />, center: true },
  Name: { content: <Skeleton height="20px" width="210px" />, center: true },
  Email: { content: <Skeleton height="20px" width="200px" />, center: true },
  Bookings: { content: <Skeleton height="30px" width="40px" />, center: true },
  "No of Vehicles": {
    content: <Skeleton height="30px" width="40px" />,
    center: true,
  },
  Action: {
    content: (
      <div className="d-flex justify-content-center gap-2">
        <Skeleton height="30px" width="30px" />
        <Skeleton height="30px" width="30px" />
      </div>
    ),
    center: true,
  },
}

const UserListSkeleton = ({ infiniteScroll, rows = 6 }) => {
  return (
    <DynamicSkeleton
      rows={rows}
      columnConfig={columnConfig}
      infiniteScroll={infiniteScroll}
    />
  )
}

export default UserListSkeleton
